<ng-template let-data #ipDialog>

  <div class="mb-3">
    <h3 mat-dialog-title>IP: {{ data.ip }}</h3>
    <mat-divider></mat-divider>
  </div>
  <div mat-dialog-content>
    <b>{{ data.org }}</b>
    <div>
      {{ data.postal }} {{ data.city }}<br/>
      {{ data.country }}
    </div>
    <mat-divider></mat-divider>
  </div>
  <div mat-dialog-actions fxLayoutAlign="end">
    <button mat-dialog-close mat-stroked-button>Luk</button>
  </div>
</ng-template>
<mat-card class="user-card">
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="start start">
      <div fxFlex="40" fxLayout="column">
        <div>{{user.name}}</div>
        <a href="mailto:{{user.email}}" [matTooltip]="'Skriv til ' + user.email">{{user.email}}</a>
      </div>
      <div fxFlex="15" fxLayout="column">
        <div>
          @switch (user.provider) {
            @case ('nemid') {
              <span>NemID</span>
            }
            @case ('mitid') {
              <span>MitID</span>
            }
            @case ('saml') {
              <span>Single Sign On</span>
            }
            @case ('otp') {
              <span>To Faktor</span>
            }
          }
        </div>
        @if (user.last_sign_in_at) {
          <div class="mat-caption">({{user.last_sign_in_at | date:'yyyy.MM.dd HH:mm'}})</div>
        }
        @if (!user.last_sign_in_at) {
          <div class="mat-caption">(Aldrig logget ind)</div>
        }
      </div>
      <div fxFlex="10">{{user.role.name}}</div>
      <div fxFlex="35" fxLayout="row" fxLayoutAlign="end center">
        @if((user.provider === 'otp' || user.provider === 'otp_sms') && user.settings.otp?.locked) {
          <mat-icon matTooltip="Bruger låst ude efter 3 engangskode forsøg">warning</mat-icon>
        }
        @if (user.last_sign_in_ip) {
          <button
            mat-icon-button
            matTooltip="Adresse for seneste login."
            aria-label="Adresse for seneste login."
            (click)="showIpInfo()"
            ><mat-icon>language</mat-icon>
          </button>
        }
        <button
          mat-icon-button
          matTooltip="Vis rettigheder"
          aria-label="Vis rettigheder"
          (click)="showPermissions()">
          <mat-icon>admin_panel_settings</mat-icon>
        </button>
        @if (user.provider === 'otp' || user.provider === 'otp_sms') {
          <button
            mat-icon-button
            matTooltip="Nulstil 2-faktor"
            aria-label="Nulstil 2-faktor"
            (click)="resetOtp()">
            <mat-icon>lock_reset</mat-icon>
          </button>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
